import React from 'react'
import classes from './FormErr.module.css'
const FormErr = props => {
  return (
    <p className={classes.err}>{props.children}</p>
  )
}

export default FormErr